import { post } from '@/utils/axios'

class IndexModel {

    // 官网获取导航栏
    async getNavigation() {
        return post('/v1/homePage/navigation')
    }

    // 官网首页获取banner
    async getBanner() {
        return post('/v1/homePage/banner')
    }

    // 官网首页获取banner
    async getScheme() {
        return post('/v1/homePage/scheme')
    }
}

export default new IndexModel()
